import { render } from "./AiReport.vue?vue&type=template&id=73f8764a&scoped=true"
import script from "./AiReport.vue?vue&type=script&lang=js"
export * from "./AiReport.vue?vue&type=script&lang=js"

import "./AiReport.vue?vue&type=style&index=0&id=73f8764a&scoped=true&lang=scss"
import "./AiReport.vue?vue&type=style&index=1&id=73f8764a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f8764a"]])

export default __exports__